import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { firebaseDB } from "../../infrastructure/firebase/firebase";
import { AppUser, AppUserId } from "../types/AppUser";
import { v4 as uuid4 } from "uuid";
import { FamilyInvitation } from "../types/FamilyInvitation";

export const sendFamilyInvitation = async (
  inviterAppUserId: AppUserId,
  inviteEmail: string,
  inviterEmail: string,
  familyId: string,
) => {
  const invitationsRef = collection(firebaseDB, "familyInvitations");
  await addDoc(invitationsRef, {
    inviterAppUserId: inviterAppUserId,
    invitedEmail: inviteEmail,
    inviterEmail: inviterEmail,
    familyId,
    status: "pending",
    createdAt: serverTimestamp(),
    invitationId: uuid4(),
  });
};

export const getInvitationData = async (invitationId: string) => {
  const invitationRef = doc(firebaseDB, "familyInvitations", invitationId);
  const invitationDoc = await getDoc(invitationRef);
  if (!invitationDoc.exists()) {
    throw new Error("Invitation not found");
  }
  return invitationDoc.data() as FamilyInvitation;
};

export const acceptFamilyInvitation = async (
  invitationId: string,
  invitedAppUser: AppUser,
) => {
  const invitationRef = doc(firebaseDB, "familyInvitations", invitationId);
  const invitationDoc = await getDoc(invitationRef);
  if (!invitationDoc.exists()) {
    throw new Error("Invitation not found");
  }
  const invitationData = invitationDoc.data();

  if (invitationData.status !== "pending") {
    throw new Error("Invitation is not valid");
  }

  await updateDoc(invitationRef, {
    status: "accepted",
    acceptedBy: invitedAppUser.appUserId,
    acceptedAt: new Date(),
  });

  const familyRef = doc(firebaseDB, "families", invitationData.familyId);
  await updateDoc(familyRef, {
    members: arrayUnion(invitedAppUser.appUserId),
  });
};

export const getFamilyInvitations = async (
  familyId: string,
): Promise<FamilyInvitation[]> => {
  const invitationsRef = collection(firebaseDB, "familyInvitations");
  const q = query(invitationsRef, where("familyId", "==", familyId));
  const querySnapshot = await getDocs(q);
  const invitations: FamilyInvitation[] = [];
  querySnapshot.forEach((doc) => {
    invitations.push(doc.data() as FamilyInvitation);
  });
  return invitations;
};
